export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/257333312cc740792702f49a1c4a9bec.jpg"
          alt="David Nieves Art"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-20 w-full text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-white mb-6 leading-tight">
            David Nieves<span className="text-[#e8a65b]">.</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed font-light">
            El arte no solo es una expresión de mi visión, sino un puente entre lo tangible y lo imaginado. Cada pincelada es una conversación entre el color, la textura y la emoción; una historia contada con la pasión de quien transforma ideas en legado.

D.Nieves
          </p>
          <button 
            onClick={() => scrollToSection('gallery')}
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#e8a65b] text-white rounded-full hover:bg-[#d99549] transition-all duration-300 text-sm font-medium whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Explorar Colección
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <button 
          onClick={() => scrollToSection('about')}
          className="animate-bounce cursor-pointer"
        >
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </button>
      </div>
    </section>
  );
}